module.exports = __webpack_public_path__ + "img/帝国盛世.93e863c8.png";